<sc-flex vertical stretchContent fitHeight>
  <sc-dialog-title>
    <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.transport-options-administration.transport-option-editor.title"></sc-dictionary-label>
  </sc-dialog-title>
  <sc-flex-fitting-content vertical>
    <sc-padding fitHeight>
      <sc-master-detail [selection]="[selectedMenuEntry]" [data]="menuEntries" [readOnly]="true"
        (selectionChanged)="onSelectionChanged($event)" [newStyle]="true">
        @if (currentViewKey === 'labeling') {
          <app-transport-option-editor-labeling [transportOption]="transportOption"
          (changed)="onDetailsChanged()"></app-transport-option-editor-labeling>
        }
        @if (currentViewKey === 'control') {
          <app-transport-option-editor-control [transportOption]="transportOption"
          (changed)="onDetailsChanged()"></app-transport-option-editor-control>
        }
        @if (currentViewKey === 'validation') {
          <app-transport-option-editor-validation [transportOption]="transportOption"
          (changed)="onDetailsChanged()"></app-transport-option-editor-validation>
        }
        @if (currentViewKey === 'loading') {
          <app-transport-option-editor-loading [transportOption]="transportOption"
          (changed)="onDetailsChanged()"></app-transport-option-editor-loading>
        }
        @if (currentViewKey === 'limits') {
          <app-transport-option-editor-limits [transportOption]="transportOption"
          (changed)="onDetailsChanged()"></app-transport-option-editor-limits>
        }
        @if (currentViewKey === 'parameter') {
          <app-transport-option-editor-parameter [transportOption]="transportOption"
          (changed)="onDetailsChanged()"></app-transport-option-editor-parameter>
        }
        @if (currentViewKey === 'files') {
          <app-transport-option-editor-files [transportOption]="transportOption"
          (changed)="onDetailsChanged()"></app-transport-option-editor-files>
        }
      </sc-master-detail>
    </sc-padding>
  </sc-flex-fitting-content>
  <sc-actionbar>
    <sc-content-spacer grow></sc-content-spacer>
    <sc-cancel-button class="cancel-button" mat-button (click)="cancelDialog()"></sc-cancel-button>
    <sc-content-spacer></sc-content-spacer>
    <sc-confirm-button primary class="confirm-button" mat-button (click)="confirmDialog()" [disabled]="!optionValid"></sc-confirm-button>
  </sc-actionbar>
</sc-flex>
